import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";

const useStyles = makeStyles(theme => ({
  modalCloseButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
    zIndex: 1
  },
  modalContent: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 320
  },
  modalImageWrap: {
    position: "relative",
    display: "inline-block"
  },
  modalImage: {
    maxWidth: "90vw",
    maxHeight: "90vh",
    objectFit: "contain",
    display: "block"
  },
  modalSlideLabel: {
    position: "absolute",
    bottom: 12,
    left: "50%",
    transform: "translateX(-50%)",
    padding: "6px 14px",
    background: "rgba(0,0,0,0.6)",
    color: "#fff",
    fontSize: 13,
    fontWeight: 600,
    borderRadius: 4
  },
  carouselPrev: {
    position: "absolute",
    left: 8,
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 1
  },
  carouselNext: {
    position: "absolute",
    right: 8,
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 1
  },
  carouselDots: {
    position: "absolute",
    bottom: 16,
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "center",
    gap: 8
  },
  carouselDot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    border: "none",
    background: "rgba(0,0,0,0.2)",
    cursor: "pointer",
    padding: 0
  },
  carouselDotActive: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    border: "none",
    background: "rgba(0,0,0,0.6)",
    cursor: "pointer",
    padding: 0,
    transform: "scale(1.2)"
  }
}));

export default function ImageCarouselDialog({ open, onClose, slides = [], initialIndex = 0, title }) {
  const classes = useStyles();
  const [slideIndex, setSlideIndex] = useState(initialIndex);

  useEffect(() => {
    if (open) setSlideIndex(initialIndex);
  }, [open, initialIndex]);

  const current = slides[slideIndex];
  const hasMultiple = slides.length > 1;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth={!!title}>
      {title && (
        <DialogTitle>
          {title}
          <IconButton aria-label="close" className={classes.modalCloseButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
      )}
      <DialogContent className={classes.modalContent} style={!title ? { position: "relative", padding: 0 } : undefined}>
        {!title && (
          <IconButton
            aria-label="close"
            onClick={onClose}
            style={{ position: "absolute", right: 8, top: 8, backgroundColor: "rgba(255, 255, 255, 0.9)", zIndex: 1 }}
          >
            <CloseIcon />
          </IconButton>
        )}
        {slides.length > 0 && (
          <>
            <div className={classes.modalImageWrap}>
              <img src={current?.url} alt="Item" className={classes.modalImage} />
              {current?.label && <span className={classes.modalSlideLabel}>{current.label}</span>}
            </div>
            {hasMultiple && (
              <>
                <IconButton
                  className={classes.carouselPrev}
                  onClick={() => setSlideIndex(i => (i - 1 + slides.length) % slides.length)}
                  aria-label="Previous"
                >
                  <ChevronLeft fontSize="large" />
                </IconButton>
                <IconButton
                  className={classes.carouselNext}
                  onClick={() => setSlideIndex(i => (i + 1) % slides.length)}
                  aria-label="Next"
                >
                  <ChevronRight fontSize="large" />
                </IconButton>
                <div className={classes.carouselDots}>
                  {slides.map((_, i) => (
                    <button
                      key={i}
                      type="button"
                      className={i === slideIndex ? classes.carouselDotActive : classes.carouselDot}
                      onClick={() => setSlideIndex(i)}
                      aria-label={`Slide ${i + 1}`}
                    />
                  ))}
                </div>
              </>
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
